import { USE_FIXTURES } from '@/api/client'

/**
 * Mockup-style badge (matches docs/design/mockups/*.html) that stays visible
 * whenever the app is rendering fixtures instead of live /admin/v2 data —
 * "never presented as live" (r0-ui-shell AWU hard constraint).
 */
export function FixturesBanner() {
  if (!USE_FIXTURES) return null
  return (
    <div className="fixed top-[62px] right-2 z-[10000] rounded-md border border-warn bg-warn-weak px-2 py-0.5 text-[11px] font-bold tracking-wide text-warn uppercase shadow-sm">
      Fixtures — sample data
    </div>
  )
}
